import type { ListBuilderList } from '../../../types';
import { createTripColumnsWithDate } from '../columns';

/**
 * Pending-Load Routes list configuration.
 *
 * Surfaces trips that the dispatch wizard has committed but the
 * warehouse manager hasn't loaded yet. This is the canonical landing
 * page for the warehouse manager — open it at the start of a shift
 * to see every truck waiting on inventory load.
 *
 * Default-sorted by scheduled start time ascending so the trucks
 * leaving earliest float to the top.
 */
export const pendingLoadTripsList: ListBuilderList = {
	id: 'pending-load-trips',
	name: 'Pending Load',
	type: 'default',
	active: true,
	cacheTTL: 600000,
	filterRules: {
		routeStatus: {
			defaultValue: [{ id: 'pending_load', label: 'Pending Load' }],
		},
	},
	columns: createTripColumnsWithDate(),
	defaultSortId: 'date-asc',
	sortOrder: 1,
};
